import {SuccessModal} from "./../SuccessModal/SuccessModal";
import React, {FC, useEffect, useRef, useState} from "react";
import {getEnvVariables} from "helpers/getEnvVariables";
import {
  useDebitWithTokenMutation,
  useGetCardsQuery,
  useSaveCardMutation,
} from "store/api/nuveiApi";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import {Loading} from "components/Loading/Loading";
import NcModal from "shared/NcModal/NcModal";
import {BuyOrderType} from "data/types";
import {useSaveOrderMutation} from "store/api";

const {
  REACT_APP_ENV_NUVEI,
  REACT_APP_APP_CODE_NUVEI,
  REACT_APP_APP_KEY_NUVEI,
  REACT_APP_URL_WEB,
} = getEnvVariables();

export interface NuveiPayphoneProps {
  amount: number;
  description: string;
  valueIva: number;
  haveIva: boolean;
  buyOrder: BuyOrderType;
}

export const Nuvei: FC<NuveiPayphoneProps> = ({
  amount,
  description,
  valueIva,
  haveIva,
  buyOrder,
}) => {
  const [saveCard] = useSaveCardMutation();
  const [debitWithToken] = useDebitWithTokenMutation();
  //  const [saveOrder] = useSaveOrderMutation();
  const {data, isLoading} = useGetCardsQuery({});
  const [cards, setCards] = useState<any[]>([]);
  const [cardSelected, setCardSelected] = useState<string>("");
  const [alertMessage, setAlert] = useState<string | null>(null);
  const [newCard, setNewCard] = useState<boolean>(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  // const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [saveOrder] = useSaveOrderMutation();

  const url = `${REACT_APP_URL_WEB}add-card.html`;
  // const url = `http://localhost:3000/add-card.html`;

  useEffect(() => {
    const sendMessageToIframe = () => {
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(
          {
            env: REACT_APP_ENV_NUVEI,
            appCode: REACT_APP_APP_CODE_NUVEI,
            appKey: REACT_APP_APP_KEY_NUVEI,
            userId: JSON.parse(localStorage.getItem("user")!)?._id,
            email: JSON.parse(localStorage.getItem("user")!)?.email,
          },
          "*"
        );
      }
    };
    iframeRef.current?.addEventListener("load", sendMessageToIframe);
    return () => {
      iframeRef.current?.removeEventListener("load", sendMessageToIframe);
    };
  }, [newCard]);

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type === "CARD_ADDED") {
        const card = event.data.data.card;
        if (card.status === "valid") {
          const creditCard = {
            user: JSON.parse(localStorage.getItem("user")!)?._id,
            number: card["number"],
            bin: card["bin"],
            type: card["type"],
            transactionReference: card["transaction_reference"],
            status: card["status"],
            token: card["token"],
            expiryYear: card["expiry_year"],
            expiryMonth: card["expiry_month"],
            origin: card["origin"],
            bankName: card["bank_name"],
            message: card["message"],
          };
          const {data} = await saveCard(creditCard);
          if (data.meta.status === 201) {
            await payWithNuvei(creditCard.token);
          } else {
            setAlert("Ocurrió un error, intenta de nuevo");
            setTimeout(() => setAlert(null), 2500);
          }
        } else {
          setAlert("Ocurrió un error, intenta de nuevo");
          setTimeout(() => setAlert(null), 2500);
        }
      }

      if (event.data?.type === "ERROR") {
        setAlert("Ocurrió un error, intenta de nuevo");
        setTimeout(() => setAlert(null), 2500);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (data && data.meta.status === 200) {
      setCards(data.data);
      setNewCard(false);
    }
  }, [data]);

  const payWithNuvei = async (cardToken: string) => {
    setIsPaying(true);
    const order = {
      buyType: "EVENT",
      amount: amount,
      description: description,
      vat: 0,
      devReference: buyOrder.order.devReference,
      userId: JSON.parse(localStorage.getItem("user")!)?._id,
      email: JSON.parse(localStorage.getItem("user")!)?.email,
      tokenCard: cardToken,
    };
    const payment = await debitWithToken(order);
    if (payment.data.meta.status === 200) {
      let newBuyOrder: BuyOrderType = {...buyOrder};
      newBuyOrder.order.devReference = order.devReference;
      newBuyOrder.order.authorizationCode =
        payment.data.data.transaction.authorization_code;
      newBuyOrder.order.transactionId = payment.data.data.transaction.id;
      console.log("newBuyOrder:", newBuyOrder);
      const {data: orderResponse, error: saveOrderError} = await saveOrder(
        newBuyOrder
      );
      if (saveOrderError) {
        setAlert("Ocurrió un error, intenta de nuevo");
        setIsPaying(false);
        setTimeout(() => setAlert(null), 2500);
        return;
      }

      if (
        orderResponse &&
        (orderResponse.meta.status === 201 || orderResponse.meta.status === 200)
      ) {
        setShowSuccessModal(true);
        setIsPaying(false);
      }
    } else {
      setAlert("Ocurrió un error, intenta de nuevo");
      setIsPaying(false);
      setTimeout(() => setAlert(null), 2500);
    }
  };

  const handlePay = async () => {
    if (cardSelected === "") {
      setAlert("Debes seleccionar una tarjeta");
      setTimeout(() => setAlert(null), 2500);
      return;
    }
    await payWithNuvei(cardSelected);
  };

  if (isLoading) return <Loading />;

  return !newCard ? (
    <div>
      <span className="inline-block text-l m-3 font-normal text-white-500">
        Selecciona una tarjeta para continuar:
      </span>
      <div className="grid lg:grid-cols-2 gap-5 xl:gap-8 max-w-screen-lg mx-auto  justify-items-center items-center">
        {cards.map((card, index) => (
          <div
            className={`relative w-72 h-44 rounded-xl shadow-xl p-4 flex flex-col justify-between 
                        backdrop-blur-s s:backdrop-blur-xl bg-white/10 bg-gradient-to-r from-gray-700/40 via-gray-500/30 to-gray-300/20 text-white transition-all duration-300 ease-in-out transform hover:shadow-lg hover:scale-105
                        ${
                          cardSelected === card.token
                            ? "border border-primary-500 border-2"
                            : ""
                        }`}
            key={index}
            onClick={() => setCardSelected(card.token)}
          >
            <div className="text-sm font-semibold opacity-80 h-10"></div>
            <div className="absolute top-10 left-4 w-12 h-8 rounded-md bg-gradient-to-r from-yellow-500 to-yellow-300 shadow-md"></div>
            <div className="text-lg text-black dark:text-white font-mono tracking-widest mt-6">
              {"**** **** **** " + card.number}
            </div>
            <div className="flex justify-between items-center text-xs mt-2">
              <span className="uppercase text-black dark:text-white font-medium">
                {card.holder_name}
              </span>
              <span className="text-xs text-black dark:text-white font-semibold">
                {card.expiry_month +
                  "/" +
                  card.expiry_year.toString().slice(-2)}
              </span>
            </div>
          </div>
        ))}
        <div
          className={`relative w-72 h-44 rounded-2xl shadow-2xl p-4 flex flex-col justify-center items-center 
                        dark:text-white text-black border border-dashed border-neutral-300 dark:border-neutral-700 cursor-pointer hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out`}
          onClick={() => {
            setNewCard(true);
          }}
        >
          <span className="text-7xl">+</span>
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <ButtonPrimary loading={isPaying} onClick={handlePay}>
          Pagar
        </ButtonPrimary>
      </div>
      {alertMessage && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex items-center gap-4">
          {alertMessage}
        </div>
      )}
      <NcModal
        isOpenProp={showSuccessModal}
        modalTitle="Compra exitosa"
        contentExtraClass="max-w-md"
        triggerText=""
        renderContent={() => <SuccessModal />}
      />
      {isPaying && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <Loading />
        </div>
      )}
    </div>
  ) : (
    <>
      <span className="inline-block text-l m-3 font-normal text-primary-500">
        Al agregar una nueva tarjeta, se realizará un cargo temporal para
        validar su autenticidad. Este importe será reembolsado automáticamente.
        Una vez completada la verificación, se procederá con el cobro
        correspondiente.
      </span>
      <iframe
        ref={iframeRef}
        src={url}
        // src={'./nuvei.html'}
        title="Nuvei Payment"
        width="100%"
        height="450px"
        style={{border: "none"}}
      />
      <NcModal
        isOpenProp={showSuccessModal}
        modalTitle="Compra exitosa"
        contentExtraClass="max-w-md"
        triggerText=""
        renderContent={() => <SuccessModal />}
      />
    </>
  );
};
